module.exports = __webpack_public_path__ + "static/media/Skiing_start.b911fa0b.mp4";